module.exports = __webpack_public_path__ + "img/logo-old.2aef9b38.png";